/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRoleDto,
  PermissionGroupResponse,
  RoleResponse,
  UpdateRoleDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * همان فهرستی که بک‌اند با آن مجوز می‌سنجد، با برچسب و توضیح فارسی، نشانهٔ حساس بودن و پیش‌نیازهای هر دسترسی. از بستهٔ مشترک می‌آید، نه از پایگاه داده، تا فقط یک منبع حقیقت وجود داشته باشد.
 * @summary فهرست دسترسی‌ها برای ویرایشگر نقش
 */
export const rolesCatalogue = (

 signal?: AbortSignal
) => {


      return apiClient<PermissionGroupResponse[]>(
      {url: `/api/v1/roles/permissions`, method: 'GET', signal
    },
      );
    }




export const getRolesCatalogueQueryKey = () => {
    return [
    `/api/v1/roles/permissions`
    ] as const;
    }


export const getRolesCatalogueQueryOptions = <TData = Awaited<ReturnType<typeof rolesCatalogue>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesCatalogueQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesCatalogue>>> = ({ signal }) => rolesCatalogue(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesCatalogueQueryResult = NonNullable<Awaited<ReturnType<typeof rolesCatalogue>>>
export type RolesCatalogueQueryError = unknown


export function useRolesCatalogue<TData = Awaited<ReturnType<typeof rolesCatalogue>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesCatalogue>>,
          TError,
          Awaited<ReturnType<typeof rolesCatalogue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesCatalogue<TData = Awaited<ReturnType<typeof rolesCatalogue>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesCatalogue>>,
          TError,
          Awaited<ReturnType<typeof rolesCatalogue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesCatalogue<TData = Awaited<ReturnType<typeof rolesCatalogue>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست دسترسی‌ها برای ویرایشگر نقش
 */

export function useRolesCatalogue<TData = Awaited<ReturnType<typeof rolesCatalogue>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesCatalogue>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesCatalogueQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * نقش‌های پیش‌فرض سامانه و نقش‌های سفارشی همین کلینیک. staffCount تعداد همکاران همین کلینیک است، نه کل سامانه.
 * @summary فهرست نقش‌ها
 */
export const rolesList = (

 signal?: AbortSignal
) => {


      return apiClient<RoleResponse[]>(
      {url: `/api/v1/roles`, method: 'GET', signal
    },
      );
    }




export const getRolesListQueryKey = () => {
    return [
    `/api/v1/roles`
    ] as const;
    }


export const getRolesListQueryOptions = <TData = Awaited<ReturnType<typeof rolesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesList>>> = ({ signal }) => rolesList(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesListQueryResult = NonNullable<Awaited<ReturnType<typeof rolesList>>>
export type RolesListQueryError = unknown


export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesList>>,
          TError,
          Awaited<ReturnType<typeof rolesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست نقش‌ها
 */

export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پیش‌نیازهای هر دسترسی خودکار افزوده می‌شوند؛ نقشی که «ویرایش بیمار» دارد ولی «مشاهده بیمار» ندارد ذخیره نمی‌شود، چون صفحهٔ ویرایش اول باید بخواند. شناسه‌های نقش‌های پیش‌فرض سامانه رزرو هستند. هیچ‌کس نمی‌تواند نقشی بسازد که دسترسی‌ای بیش از دسترسی‌های خودش داشته باشد.
 * @summary ساخت نقش سفارشی
 */
export const rolesCreate = (
    createRoleDto: CreateRoleDto,
 signal?: AbortSignal
) => {


      return apiClient<RoleResponse>(
      {url: `/api/v1/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoleDto, signal
    },
      );
    }




export const getRolesCreateMutationKey = () => ['rolesCreate'] as const;

export const getRolesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesCreate>>, TError,RolesCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rolesCreate>>, TError,RolesCreateMutationVariables, TContext> => {

const mutationKey = getRolesCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesCreate>>, RolesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  rolesCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RolesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof rolesCreate>>>
    export type RolesCreateMutationBody = CreateRoleDto
    export type RolesCreateMutationError = void
    export type RolesCreateMutationVariables = {data: CreateRoleDto}

    /**
 * @summary ساخت نقش سفارشی
 */
export const useRolesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesCreate>>, TError,RolesCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rolesCreate>>,
        TError,
        RolesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getRolesCreateMutationOptions(options), queryClient);
    }
    /**
 * @summary یک نقش
 */
export const rolesGet = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<RoleResponse>(
      {url: `/api/v1/roles/${id}`, method: 'GET', signal
    },
      );
    }




export const getRolesGetQueryKey = (id: string,) => {
    return [
    `/api/v1/roles/${id}`
    ] as const;
    }


export const getRolesGetQueryOptions = <TData = Awaited<ReturnType<typeof rolesGet>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesGet>>> = ({ signal }) => rolesGet(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RolesGetQueryResult = NonNullable<Awaited<ReturnType<typeof rolesGet>>>
export type RolesGetQueryError = void


export function useRolesGet<TData = Awaited<ReturnType<typeof rolesGet>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesGet>>,
          TError,
          Awaited<ReturnType<typeof rolesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesGet<TData = Awaited<ReturnType<typeof rolesGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesGet>>,
          TError,
          Awaited<ReturnType<typeof rolesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRolesGet<TData = Awaited<ReturnType<typeof rolesGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک نقش
 */

export function useRolesGet<TData = Awaited<ReturnType<typeof rolesGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rolesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRolesGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * تغییر فهرست دسترسی‌ها، توکن‌های فعال همهٔ دارندگان این نقش را بی‌اعتبار می‌کند تا تغییر همان لحظه اعمال شود؛ تغییر نام این کار را نمی‌کند. شناسهٔ نقش پس از ساخت تغییر نمی‌کند. افزودن دسترسی‌ای که ویرایش‌کننده خودش ندارد پذیرفته نمی‌شود، ولی حذف همان دسترسی و ویرایش سایر بخش‌های نقش همیشه مجاز است.
 * @summary ویرایش نقش سفارشی
 */
export const rolesUpdate = (
    id: string,
    updateRoleDto: UpdateRoleDto,
 signal?: AbortSignal
) => {


      return apiClient<RoleResponse>(
      {url: `/api/v1/roles/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRoleDto, signal
    },
      );
    }




export const getRolesUpdateMutationKey = () => ['rolesUpdate'] as const;

export const getRolesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,RolesUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,RolesUpdateMutationVariables, TContext> => {

const mutationKey = getRolesUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesUpdate>>, RolesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  rolesUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RolesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUpdate>>>
    export type RolesUpdateMutationBody = UpdateRoleDto
    export type RolesUpdateMutationError = void
    export type RolesUpdateMutationVariables = {id: string;data: UpdateRoleDto}

    /**
 * @summary ویرایش نقش سفارشی
 */
export const useRolesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,RolesUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rolesUpdate>>,
        TError,
        RolesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getRolesUpdateMutationOptions(options), queryClient);
    }
    /**
 * نقشی که به همکاری اختصاص داده شده یا در دعوتی در انتظار آمده حذف نمی‌شود؛ حذف آن این افراد را بدون هیچ دسترسی رها می‌کرد.
 * @summary حذف نقش سفارشی
 */
export const rolesRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/roles/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getRolesRemoveMutationKey = () => ['rolesRemove'] as const;

export const getRolesRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesRemove>>, TError,RolesRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rolesRemove>>, TError,RolesRemoveMutationVariables, TContext> => {

const mutationKey = getRolesRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesRemove>>, RolesRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  rolesRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RolesRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof rolesRemove>>>

    export type RolesRemoveMutationError = void
    export type RolesRemoveMutationVariables = {id: string}

    /**
 * @summary حذف نقش سفارشی
 */
export const useRolesRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesRemove>>, TError,RolesRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rolesRemove>>,
        TError,
        RolesRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getRolesRemoveMutationOptions(options), queryClient);
    }
